import React from "react";
import InputField from "../../components/subcomponents/controls/inputfield";
import SelectField from "../../components/subcomponents/controls/selectfield";
import Button from "../../components/subcomponents/controls/button";
import FormHeader from "../../components/subcomponents/formheader";
import { connect } from "react-redux";
import module from "../../api/module";
import module_component from "../../api/module_component";
import notification from "../../components/subcomponents/notification";
import SubformDetails from "../../components/subcomponents/subform_details";
import Table from "../../components/subcomponents/table";
import ToggleField from "../../components/subcomponents/controls/togglefield";

class moduleEdit extends React.Component {
  componentWillMount() {
    let cur_obj = this;
    if (this.props.match.params.mode === "update") {
      module.details(function (error, response) {
        if (error) {
          cur_obj.props.history.replace("/module_list");
        } else {
          module_component.linked_list(function () {});
        }
      });
    }
    module.options();
  }
  controllersForSelect() {
    let select_array = [];
    if (Array.isArray(this.props.module_free_controllers)) {
      this.props.module_free_controllers.forEach(function (row) {
        select_array.push({
          value: row.controller_id,
          label: row.controller_alias + "/" + row.controller_mac,
        });
      });
    }
    return select_array;
  }
  componentsForSelect() {
    let select_array = [];
    if (Array.isArray(this.props.module_free_components)) {
      this.props.module_free_components.forEach(function (row) {
        select_array.push({
          value: row.component_id,
          label: row.component_name + "/" + row.component_interface,
        });
      });
    }
    return select_array;
  }
  selectClassProp(class_prop, row) {
    if (class_prop) {
      if (row.component_id) {
        this.props.handleSelectClassProp(row);
        module_component.details(function (error, response) {
          if (error) notification.error(error.message);
          module_component.component_classes_for_component_type(function (err) {
            if (err) notification.error(err.api_error.message);
          });
        });
      } else {
        this.props.handleSelectClassProp(row);
        module_component.component_classes_for_component_type(function (err) {
          if (err) notification.error(err.api_error.message);
        });
      }
    } else {
      this.props.handleSelectClassProp(null);
    }
  }
  selectComponentClass(component_class, row) {
    console.log(component_class);
    this.props.fieldComponentChange(component_class);
    module_component.free_controllers_for_component_class(() => {});
  }
  fieldControllerSelectChange(controller_select) {
    this.props.handleSelectController(controller_select.value);
    if (controller_select.value) {
      module_component.free_components_for_component_class(function (
        error,
        response
      ) {
        if (error) notification.error(error.message);
      });
    }
  }
  handleSave() {
    let cur_obj = this;
    if (this.props.match.params.mode === "update") {
      module.update(function (error, response) {
        if (!error) {
          cur_obj.props.history.replace("/module_list");
        }
      });
    } else {
      module.add(function (error, response) {
        if (!error) {
          module.details(function () {
            cur_obj.props.history.replace("/module/update");
            module_component.linked_list(function () {});
          });
        } else {
          console.log(error);
          notification.error(error.message);
        }
      });
    }
  }
  updateFreeComponent() {
    let self = this;
    let class_prop = this.props.module_class_prop_selected;
    let selected = {
      class_prop: this.props.module_class_prop_selected,
      component_id: this.props.module_free_component_selected,
      component_type: this.props.module_component_type_selected,
    };
    module_component.update_free_component(function (err, response) {
      if (err) {
        notification.error(err.api_error.message);
      } else {
        module_component.linked_list(function () {
          self.selectClassProp(class_prop, selected);
        });
      }
    });
  }
  updateComponent() {
    module_component.update(function (err, response) {
      if (err) {
      } else {
        module_component.linked_list(function () {});
        module_component.component_classes_for_component_type(function (
          err
        ) {});
      }
    });
  }
  clearComponent() {
    module_component.clear_component(function (err, response) {
      if (err) {
        notification.error(err.api_error.message);
      } else {
        module_component.linked_list(function () {});
      }
    });
  }
  handleCancel() {
    this.props.history.replace("/module_list");
  }
  formModuleDetails() {
    if (!this.props.module_id) {
      return (
        <SubformDetails
          title={
            this.props.match.params.mode === "update"
              ? "Edit record with ID: " + this.props.module_id
              : "Add new record"
          }
          className="details width_100"
        >
          <InputField
            name="module_name"
            label="Name (min. 4 chars)"
            onChange={this.props.fieldChange}
            value={this.props.module_name}
            error={this.props.module_validation["module_name"]}
          />
          <SelectField
            status={this.props.module_class_id_status}
            name="module_class_id"
            label="Module type"
            options={this.props.module_options["module_class_id"]}
            onChange={this.props.fieldChange}
            value={this.props.module_class_id}
            error={this.props.module_validation["module_class_id"]}
          />
          <div className="toolbar">
            <Button
              name="save"
              label="Save"
              status={this.props.module_save_btn}
              onClick={this.handleSave.bind(this)}
            />
            <Button
              name="cancel"
              label="Cancel"
              onClick={this.handleCancel.bind(this)}
            />
          </div>
        </SubformDetails>
      );
    } else {
      return (
        <SubformDetails
          title={
            this.props.match.params.mode === "update"
              ? "Edit record with ID: " + this.props.module_id
              : "Add new record"
          }
          className="details width_100"
        >
          <InputField
            name="module_name"
            label="Name (min. 4 chars)"
            onChange={this.props.fieldChange}
            value={this.props.module_name}
            error={this.props.module_validation["module_name"]}
          />
          <InputField
            name="module_description"
            label="Description"
            onChange={this.props.fieldChange}
            value={this.props.module_description}
            error={this.props.module_validation["module_description"]}
          />
          <div className="toolbar">
            <Button
              name="save"
              label="Save"
              status={this.props.module_save_btn}
              onClick={this.handleSave.bind(this)}
            />
            <Button
              name="cancel"
              label="Cancel"
              onClick={this.handleCancel.bind(this)}
            />
          </div>
        </SubformDetails>
      );
    }
  }
  formComponentList() {
    return (
      <div>
        <SubformDetails className="details width_100">
          <FormHeader title="Module components" />
          <Table
            name="module_component_list"
            table_key={"class_prop"}
            selected={this.props.module_class_prop_selected}
            handleSelect={this.selectClassProp.bind(this)}
            headers={{
              class_prop: { label: "Name", width: "15%" },
              component_class: { label: "Class", width: "15%" },
              controller_name: { label: "Controller", width: "25%" },
              component_name: { label: "Connector", width: "15%" },
              component_id: { label: "ID", width: "10%" },
              disabled: { label: "Disabled", width: "10%" },
            }}
            data={this.props.module_component_list}
          />
        </SubformDetails>
      </div>
    );
  }
  formSelectComponent() {
    let component_select_enabled = this.props.module_free_controller_selected
      ? "enabled"
      : "disabled";
    let show_update_button =
      this.props.module_free_component_selected &&
      this.props.module_free_controller_selected &&
      this.props.module_free_component_selected
        ? "enabled"
        : "disabled";
    if (
      this.props.module_class_prop_selected &&
      !this.props.module_component_selected
    ) {
      return (
        <SubformDetails
          title="Select controller for module"
          className="details width_50"
        >
          <SelectField
            name="component_class"
            label="Component class"
            allowEmpty={false}
            options={this.props.module_component_component_classes}
            onChange={this.selectComponentClass.bind(this)}
            value={this.props.module_component_component_class}
          />
          <SelectField
            name="controller_id"
            label="Controller"
            allowEmpty={true}
            options={this.controllersForSelect()}
            onChange={this.fieldControllerSelectChange.bind(this)}
            value={this.props.module_free_controller_selected}
          />
          <SelectField
            name="component_id"
            label="Connector"
            allowEmpty={true}
            status={component_select_enabled}
            options={this.componentsForSelect()}
            onChange={this.props.handleSelectFreeComponent}
            value={this.props.module_free_component_selected}
          />
          <div className="toolbar">
            <Button
              name="add"
              label="Update component"
              status={show_update_button}
              onClick={this.updateFreeComponent.bind(this)}
            />
          </div>
        </SubformDetails>
      );
    } else {
      return null;
    }
  }
  formComponentDetails() {
    if (this.props.module_component_selected) {
      return (
        <SubformDetails
          title="Edit component area"
          className="details width_50"
        >
          <h3>Name: {this.props.module_component_class_prop}</h3>
          <h3>Class: {this.props.module_component_component_class}</h3>
          <h3>Connector: {this.props.module_component_component_name}</h3>
          <div className="group_options">
            <ToggleField
              name="disabled"
              label="Disable component"
              onChange={this.props.fieldComponentChange}
              value={this.props.module_component_disabled}
            />
            {this.formComponentConfig()}
          </div>

          <div className="toolbar">
            <Button
              name="add"
              label="Update component"
              onClick={this.updateComponent.bind(this)}
            />
            <Button
              name="clear"
              label="Clear component"
              onClick={this.clearComponent.bind(this)}
            />
          </div>
        </SubformDetails>
      );
    } else {
      return null;
    }
  }
  formModuleConfig() {
    let module_config = this.props.module_config;
    let module_config_params = this.props.module_config_params;
    let module_options = this.props.module_options;
    let on_change = this.props.fieldChange;
    let validation = this.props.module_validation;
    if (module_config_params) {
      return (
        <SubformDetails title="Module config" className="details width_50">
          {Object.keys(module_config_params).map(function (field_name) {
            if (module_config_params[field_name].type === "text")
              return (
                <InputField
                  key={field_name}
                  name={field_name}
                  onChange={on_change}
                  input_control={module_config_params[field_name].input_control}
                  label={module_config_params[field_name].label}
                  error={validation[field_name]}
                  value={module_config[field_name]}
                />
              );
            else if (module_config_params[field_name].type === "number")
              return (
                <InputField
                  key={field_name}
                  name={field_name}
                  onChange={on_change}
                  label={module_config_params[field_name].label}
                  error={validation[field_name]}
                  value={module_config[field_name]}
                />
              );
            else if (module_config_params[field_name].type === "select")
              return (
                <SelectField
                  key={field_name}
                  name={field_name}
                  label={module_config_params[field_name].label}
                  allowEmpty={module_config_params[field_name].allow_empty}
                  options={
                    module_options[module_config_params[field_name].options]
                  }
                  onChange={on_change}
                  error={validation[field_name]}
                  value={module_config[field_name]}
                />
              );
            else if (module_config_params[field_name].type === "boolean")
              return (
                <ToggleField
                  key={field_name}
                  name={field_name}
                  label={module_config_params[field_name].label}
                  onChange={on_change}
                  value={module_config[field_name]}
                />
              );
            else return <></>;
          })}
        </SubformDetails>
      );
    } else return null;
  }
  formComponentConfig() {
    let component_config = this.props.component_config;
    let component_config_params = this.props.component_config_params;
    let on_change = this.props.fieldComponentChange;
    let validation = this.props.component_validation;
    if (component_config_params) {
      return (
        <div>
          {Object.keys(component_config_params).map(function (field_name) {
            if (component_config_params[field_name].type === "number")
              return (
                <InputField
                  key={field_name}
                  name={field_name}
                  onChange={on_change}
                  label={component_config_params[field_name].label}
                  error={validation[field_name]}
                  value={component_config[field_name]}
                />
              );
            else if (component_config_params[field_name].type === "boolean")
              return (
                <ToggleField
                  key={field_name}
                  name={field_name}
                  label={component_config_params[field_name].label}
                  onChange={on_change}
                  value={component_config[field_name]}
                />
              );
            else return <></>;
          })}
        </div>
      );
    } else return null;
  }
  render() {
    //console.log(this.props.module_config);
    return (
      <div className="form_wrap module_edit">
        <FormHeader title={"MODULES EDIT"} />
        {this.formModuleDetails()}
        {this.formModuleConfig()}
        {this.formComponentList()}
        {this.formSelectComponent()}
        {this.formComponentDetails()}
      </div>
    );
  }
}

function stateArr(obj) {
  let state_arr = [];
  if (obj)
    Object.keys(obj).forEach((field) => {
      state_arr.push(obj[field]);
    });
  return state_arr;
}

function mapStateToProps(state) {
  let module_single = state.moduleR.module;
  let module_config = state.moduleR.module_config;
  let module_config_params = state.moduleR.module_config_params;
  //console.log(module_config.access_area_id);
  let module_component = state.moduleR.module_component;
  let free_controllers = state.moduleR.free_controllers;
  let free_components = state.moduleR.free_components;

  let component_config = state.moduleR.component_config;
  let component_config_params = state.moduleR.component_config_params;

  return {
    module_validation: module_single.validation,
    module_save_btn:
      module_single.details.module_name &&
      module_single.details.module_class_id !== ""
        ? "enabled"
        : "disabled",

    module_id: module_single.details.module_id,
    module_name: module_single.details.module_name,
    module_description: module_single.details.module_description,
    module_class_id: module_single.details.module_class_id,
    module_options: module_single.options,

    module_class_id_status:
      module_single.details.module_id > 1 ? "disabled" : false,

    module_component_list: module_component.list,
    module_component_component_classes: module_component.component_classes,

    module_free_controllers: free_controllers.list,
    module_free_controller_selected: free_controllers.selected,

    module_free_components: free_components.list,
    module_free_component_selected: free_components.selected,

    module_class_prop_selected: free_controllers.req_class_prop,
    module_component_type_selected: free_controllers.req_component_type,

    module_component_selected: module_component.details.component_id,
    //module config
    module_config: module_config,
    module_config_params: module_config_params,
    module_config_state: stateArr(module_config),

    //module details

    module_component_class_prop: module_component.details.class_prop,
    module_component_component_class: module_component.details.component_class,
    module_component_component_type: module_component.details.component_type,
    module_component_component_name: module_component.details.component_name,
    module_component_module_id: module_component.details.module_id,
    module_component_controller_name: module_component.details.controller_name,
    module_component_disabled: module_component.details.disabled,

    module_component_free_areas: module_component.free_areas,

    module_empty_class_prop_selected: free_controllers.req_class_prop,

    component_validation: module_component.validation,
    component_config: component_config,
    component_config_params: component_config_params,
    component_config_state: stateArr(component_config),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleSelectClassProp(row) {
      if (row && row.component_id) {
        dispatch({
          type: "MODULE_COMPONENT_SELECTED",
          value: row.component_id,
        });
      } else {
        dispatch({
          type: "MODULE_COMPONENT_DESELECTED",
        });
      }
      if (row && row.class_prop) {
        dispatch({
          type: "MODULE_CLASS_PROP_SELECTED",
          class_prop_value: row.class_prop,
          component_type_value: row.component_type,
        });
      } else {
        dispatch({
          type: "MODULE_CLASS_PROP_DESELECTED",
        });
      }
    },
    handleSelectController(controller_id) {
      if (controller_id) {
        dispatch({
          type: "FREE_CONTROLLER_SELECTED",
          value: controller_id,
        });
      } else {
        dispatch({
          type: "FREE_CONTROLLER_DESELECTED",
        });
      }
    },
    handleSelectFreeComponent(result) {
      if (result.value) {
        dispatch({
          type: "FREE_COMPONENT_SELECTED",
          value: result.value,
        });
      } else {
        dispatch({
          type: "FREE_COMPONENT_DESELECTED",
        });
      }
    },
    fieldChange(result) {
      dispatch({
        type: "MODULE_UPDATE_FORM",
        field: result.name,
        value: result.value,
      });
    },
    fieldComponentChange(result) {
      dispatch({
        type: "MODULE_COMPONENT_UPDATE_FORM",
        field: result.name,
        value: result.value,
      });
    },
  };
}

export default moduleEdit = connect(
  mapStateToProps,
  mapDispatchToProps
)(moduleEdit);
